import React, { FunctionComponent } from 'react';

import LayoutContainer from 'components/layout/LayoutContainer';
import ArticleAuthor from 'components/modules/public/blogs/ArticleAuthor';
import ArticleCategoriesAside from 'components/modules/public/blogs/ArticleCategoriesAside';
import ArticleCategoriesList from 'components/modules/public/blogs/ArticleCategoriesList';
import ArticleContent from 'components/modules/public/blogs/ArticleContent';
import ArticleCta from 'components/modules/public/blogs/ArticleCta';
import ArticleIndex from 'components/modules/public/blogs/ArticleIndex';
import ArticleRating from 'components/modules/public/blogs/ArticleRating';
import ArticleSocials from 'components/modules/public/blogs/ArticleSocials';
import ArticleWrapper from 'components/modules/public/blogs/ArticleWrapper';

import { Props } from './index';
import StyledComponent from './styles';

const PublicPageArticleSectionArticle: FunctionComponent<Props> = ({ article, articleCategories, articleContentCopy }) => {
    return (
        <StyledComponent className="public-page-article-section-article">
            <ArticleWrapper article={article}>
                {(content, indexStructure) => {
                    return (
                        <>
                            <LayoutContainer>
                                <ArticleCategoriesList
                                    categories={[
                                        article?.category,
                                        ...(article?.sideCategories || []),
                                    ]}
                                />
                            </LayoutContainer>
                            <LayoutContainer>
                                <div className="wrapper-article">
                                    <div className="article">
                                        <div className="article-content">
                                            {indexStructure && Object.keys(indexStructure).length > 0 && (
                                                <div className="article-content-list">
                                                    <div className="list-headline">
                                                        {articleContentCopy?.listHeadline}
                                                    </div>
                                                    <ArticleIndex indexStructure={indexStructure} />
                                                </div>
                                            )}
                                            <ArticleContent
                                                content={content}
                                                article={article}
                                            />
                                            <ArticleCta article={article} />
                                            <ArticleRating
                                                article={article}
                                                translations={articleContentCopy.rate}
                                            />
                                            <ArticleAuthor
                                                article={article}
                                                translations={articleContentCopy.author}
                                            />

                                            <ArticleSocials
                                                article={article}
                                                translations={articleContentCopy.socials}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="wrapper-side">
                                    <ArticleCategoriesAside categories={articleCategories} />
                                </div>
                            </LayoutContainer>
                        </>
                    );
                }}
            </ArticleWrapper>
        </StyledComponent>
    );
};

export default PublicPageArticleSectionArticle;
